import axiosClient from "./axiosClient";

export const preloadApi = {
    getPreloadData: () => {
        const url = 'api/preload';
        return axiosClient.get(url);
    },
};
